/**
 * Shared Zod schemas for moon app forms. Audit task 2.3.
 *
 * Each form has its own schema file; this index re-exports them so
 * consumers can import from a single path:
 *
 *   import { insuranceFormSchema, type InsuranceFormValues } from "@src/packages/schemas";
 *
 * Forms migrated from ad-hoc useState validation to React Hook Form +
 * Zod resolver. The schema is the source of truth for required fields,
 * value shapes, and inline error messages.
 */

export {
  insuranceFormSchema,
  type InsuranceFormValues,
} from "./insuranceForm";
export {
  partnerInviteSchema,
  type PartnerInviteValues,
} from "./partnerInvite";
export {
  createAccountSchema,
  createAccountPhoneSchema,
  createAccountOtpSchema,
  PHONE_MIN_DIGITS,
  OTP_LENGTH,
  type CreateAccountValues,
  type CreateAccountPhoneValues,
  type CreateAccountOtpValues,
} from "./createAccount";
export {
  addAppointmentSchema,
  validateAppointmentDraft,
  isRealCalendarDate,
  isValidClockTime,
  type AddAppointmentValues,
  type AppointmentDraftValidation,
} from "./addAppointment";
export {
  addMedicationSchema,
  parseDoseInput,
  validateMedicationDraft,
  MAX_DOSE_AMOUNT,
  type AddMedicationValues,
  type DoseParseResult,
  type MedicationDraftValidation,
} from "./addMedication";
export {
  addSpecimenSchema,
  type AddSpecimenValues,
} from "./addSpecimen";
export {
  documentReviewSchema,
  type DocumentReviewValues,
} from "./documentReview";
export {
  testResultEntrySchema,
  type TestResultEntryValues,
} from "./testResultEntry";
